import { useRef } from "react";
import { useSpacetimeGrid, type GridPalette } from "@/hooks/useSpacetimeGrid";

const LIGHT: GridPalette = {
  gridPrimary: "30,100,130",
  gridSecondary: "50,120,150",
  gridAlpha: 0.28,
  particleColors: [
    "40,140,180",
    "30,110,150",
    "60,160,200",
    "20,90,130",
    "50,130,170",
  ],
  particleBrightnessRange: null,
  particleOpacityMin: 0.2,
  particleOpacityMax: 0.5,
  particleComposite: "source-over",
  cursorInner: "rgba(126,230,255,0.10)",
  cursorOuter: "rgba(126,230,255,0)",
  cursorComposite: "source-over",
};

const DARK: GridPalette = {
  gridPrimary: "126,230,255",
  gridSecondary: "182,140,255",
  gridAlpha: 0.18,
  particleColors: null,
  particleBrightnessRange: [180, 235],
  particleOpacityMin: 0.2,
  particleOpacityMax: 0.55,
  particleComposite: "lighter",
  cursorInner: "rgba(126,230,255,0.07)",
  cursorOuter: "rgba(126,230,255,0)",
  cursorComposite: "lighter",
};

export function SpacetimeGrid({
  optimizeForMobile = false,
  lowPower = false,
}: {
  optimizeForMobile?: boolean;
  lowPower?: boolean;
}) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useSpacetimeGrid(canvasRef, LIGHT, DARK, { optimizeForMobile, lowPower });

  // Safari turns edge-flush fixed layers into a solid browser-toolbar tint.
  return (
    <div className="pointer-events-none fixed inset-px z-0 overflow-hidden">
      <canvas
        ref={canvasRef}
        className="spacetime-canvas block h-full w-full"
      />
    </div>
  );
}
